import { FieldMappings } from '@/app/features/products/common/components/frontend-processing/models';
import { InputLayoutModel, InputLayoutField } from '@ssar-app/domain';

export const toInputLayoutModel = (
  fields: FieldMappings[],
  hasHeaders: boolean,
): InputLayoutModel[] => {
  let start = 1;
  const toReturn: InputLayoutModel[] = fields.map((item) => {
    const field: InputLayoutModel = {
      clientHeaders: hasHeaders ? item.field : '',
      fieldName: item.headerNameWithLength?.name || undefined,
      length: item.headerNameWithLength?.fieldLength,
      start: start,
      source: 'Client',
    };
    start += item.headerNameWithLength?.fieldLength;
    return field;
  });
  return toReturn;
};

export const toInputLayoutFields = (
  fields: FieldMappings[],
  hasHeaders: boolean,
): InputLayoutField[] => {
  const toReturn: InputLayoutField[] = fields.map((item) => {
    const field: InputLayoutField = {
      name: item.headerNameWithLength?.name || undefined,
      headerName: hasHeaders ? item.field : '',
      fieldLength: item.headerNameWithLength?.fieldLength,
    };
    return field;
  });
  return toReturn;
};
